import { post } from './requests'

const resourcePath = 'events'
export function createEvent (event) {
  return post(resourcePath, { event })
}
